export default () => ({
	isFiltersActive: false,
	activeSort: 'best-selling',

	changeCollectionMainContent(url) {
		fetch(url)
			.then((res) => res.text())
			.then((data) => {
				const html = new DOMParser().parseFromString(data, 'text/html');
				const destination = document.querySelector('.collection-main__grid-container');
				const source = html.querySelector('.collection-main__grid-container');
				const filterPopupDestination = document.querySelector('.collection-main__filter-popup');
				const filterPopupSource = html.querySelector('.collection-main__filter-popup');
				const collectionFaqDestination = document.querySelector('.colection-main__faq');
				const collectionFaqSource = html.querySelector('.colection-main__faq');
				if (source && destination) {
					destination.innerHTML = source.innerHTML;
				}

				if (filterPopupDestination && filterPopupSource) {
					filterPopupDestination.innerHTML = filterPopupSource.innerHTML;
				}

				if (collectionFaqDestination && collectionFaqSource) {
					collectionFaqDestination.innerHTML = collectionFaqSource.innerHTML;
				} else {
					if (collectionFaqDestination) {
						collectionFaqDestination.innerHTML = '';
					}
				}
			});
	},

	filterBySubcollection() {
		const buttons = document.querySelectorAll('.sub-collections__trigger');
		buttons.forEach((button) => button.classList.remove('active'));
		this.$el.classList.add('active');

		const url = this.$el.dataset.link + `?section_id=${this.$root.dataset.sectionId}`;

		this.changeCollectionMainContent(url);
		history.pushState({}, '', this.$el.dataset.link);
	},

	paginate() {
		const url =
			this.$el.querySelector('a').getAttribute('href') +
			`&section_id=${this.$root.dataset.sectionId}`;

		this.changeCollectionMainContent(url);
		history.pushState({}, '', this.$el.querySelector('a').getAttribute('href'));
		setTimeout(() => {
			this.scrollToStart();
		}, 200);
	},

	filterAndSort() {
		const baseUrl = this.$el.dataset.collectionUrl;
		let data = new FormData(this.$el);
		let queryString = new URLSearchParams(data).toString();
		const activeSort = queryString
			.split('&')
			.find((element) => element.includes('sort_by'))
			?.split('=')[1];
		this.activeSort = activeSort || 'manual';
		const url = baseUrl + '?' + queryString;

		this.changeCollectionMainContent(url);
		history.pushState({}, '', url);
	},

	searchSort() {
		const baseUrl = window.location.href;
		let data = new FormData(this.$el);
		let queryString = new URLSearchParams(data).toString();
		const activeSort = queryString
			.split('&')
			.find((element) => element.includes('sort_by'))
			?.split('=')[1];

		this.activeSort = activeSort || 'manual';
		const url = baseUrl + '&' + queryString;

		this.changeCollectionMainContent(url);
		history.pushState({}, '', url);
	},

	removeActiveFilter() {
		const url = this.$el.getAttribute('href');

		this.changeCollectionMainContent(url);
		history.pushState({}, '', url);
	},

	removeAllFilters() {
		const url = window.location.href.replace(window.location.search, '');

		this.changeCollectionMainContent(url);
		history.pushState({}, '', url);
		this.isFiltersActive = false;
	},

	closePopupByOverlay() {
		if (this.$event.target === this.$el) {
			this.isFiltersActive = false;
		}
	},

	scrollToStart() {
		const collection_container = document.querySelector('.collection-main');
		if (collection_container) {
			const top = collection_container.offsetTop - 150;

			window.scrollTo({
				top: top,
				behavior: 'smooth',
			});
		}
	},

	handleFilterScroll() {
		if (window.innerWidth < 1024) {
			const scroll_width = this.$el.offsetWidth + this.$el.scrollLeft + 50;
			if (scroll_width > this.$el.scrollWidth) {
				this.$refs.filterOpacity.style.display = 'none';
			} else {
				this.$refs.filterOpacity.style.display = 'block';
			}
		}
	},

	init() {
		this.$watch('isFiltersActive', (value) => {
			value ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'auto');
		});

		window.addEventListener('popstate', () => {
			const url = document.location.href;

			this.changeCollectionMainContent(url);

			const buttons = document.querySelectorAll('.sub-collections__trigger');
			buttons.forEach((button) => {
				if (window.location.href.includes(button.dataset.link)) {
					button.classList.add('active');
				} else {
					button.classList.remove('active');
				}
			});
		});
	},
});
